// ============================================================
// Muscle Gummies theme JS — reveal, cart drawer, variants, sticky ATC
// ============================================================
(function(){
  'use strict';

  /* ---- Scroll reveal ---- */
  function initReveal(){
    var els = document.querySelectorAll('.mg-reveal');
    if(!('IntersectionObserver' in window) || !els.length){
      els.forEach(function(e){e.classList.add('is-visible');}); return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold:0.12 });
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---- Cart drawer ---- */
  function openDrawer(){ document.querySelector('[data-mg-drawer]')?.classList.add('is-open'); document.querySelector('[data-mg-overlay]')?.classList.add('is-open'); }
  function closeDrawer(){ document.querySelector('[data-mg-drawer]')?.classList.remove('is-open'); document.querySelector('[data-mg-overlay]')?.classList.remove('is-open'); }

  function money(cents){ return '£' + (cents/100).toFixed(2); }

  function renderCart(cart){
    var body = document.querySelector('[data-mg-drawer-body]');
    var sub  = document.querySelector('[data-mg-drawer-subtotal]');
    var count= document.querySelector('.mg-cart-count');
    if(!body) return;
    if(cart.item_count === 0){ body.innerHTML = '<p>Your cart is empty.</p>'; }
    else {
      body.innerHTML = cart.items.map(function(it){
        return '<div class="mg-drawer__item">'+
          (it.image ? '<img src="'+it.image+'" alt="">' : '')+
          '<div><strong>'+it.product_title+'</strong><br>'+
          '<small>'+(it.variant_title && it.variant_title!=='Default Title' ? it.variant_title+' · ' : '')+'Qty '+it.quantity+'</small><br>'+
          money(it.final_line_price)+'</div></div>';
      }).join('');
    }
    if(sub) sub.textContent = money(cart.total_price);
    if(count) count.textContent = cart.item_count;
  }

  function refreshCart(open){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ renderCart(c); if(open) openDrawer(); });
  }

  // Intercept product add-to-cart forms
  function initAjaxCart(){
    document.addEventListener('submit', function(e){
      var form = e.target.closest('form[action*="/cart/add"]');
      if(!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if(btn){ btn.disabled=true; }
      fetch('/cart/add.js', { method:'POST', body:new FormData(form), headers:{'Accept':'application/json'} })
        .then(function(r){return r.json();})
        .then(function(){ refreshCart(true); })
        .catch(function(){ form.submit(); })
        .finally(function(){ if(btn){ btn.disabled=false; } });
    });
    // open drawer when clicking the cart icon
    document.addEventListener('click', function(e){
      if(e.target.closest('[data-mg-cart-open]')){ e.preventDefault(); refreshCart(true); }
      if(e.target.closest('[data-mg-drawer-close]') || e.target.closest('[data-mg-overlay]')){ closeDrawer(); }
    });
  }

  /* ---- Variant switching (product page) ---- */
  function initVariants(){
    var root = document.querySelector('[data-mg-product]');
    if(!root) return;
    var data = root.querySelector('[data-mg-variants]');
    if(!data) return;
    var variants = JSON.parse(data.textContent);
    var selects = root.querySelectorAll('select[data-mg-option]');
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-mg-price]');
    var img = document.getElementById('mg-main-image');
    function update(){
      var chosen = Array.from(selects).map(function(s){return s.value;});
      var match = variants.find(function(v){ return v.options.join('~~') === chosen.join('~~'); });
      if(!match) return;
      if(idInput) idInput.value = match.id;
      if(priceEl) priceEl.innerHTML = (match.compare_at_price>match.price ? '<s>'+money(match.compare_at_price)+'</s> ' : '') + money(match.price);
      if(img && match.featured_image) img.src = match.featured_image;
    }
    selects.forEach(function(s){ s.addEventListener('change', update); });
  }

  /* ---- Sticky add-to-cart ---- */
  function initSticky(){
    var bar = document.querySelector('.mg-sticky-atc');
    var anchor = document.querySelector('[data-mg-atc-anchor]');
    if(!bar || !anchor) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ bar.classList.toggle('is-visible', !en.isIntersecting); });
    });
    io.observe(anchor);
  }

  /* ---- Bottle shake on load ---- */
  function initShake(){
    var bottle = document.querySelector('.mg-product');
    if(!bottle) return;
    // trigger the one-time shake shortly after load
    setTimeout(function(){
      bottle.classList.add('mg-shake-load');
      bottle.addEventListener('animationend', function(){ bottle.classList.remove('mg-shake-load'); }, { once:true });
    }, 700);
  }

  document.addEventListener('DOMContentLoaded', function(){
    initReveal(); initAjaxCart(); initVariants(); initSticky(); initShake();
  });
})();
